import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companyDetails: null,
  billingAddresses: null,
  pickupAddresses: null,
};

const addUserSlice = createSlice({
  name: "addUser",
  initialState,
  reducers: {
    fetchCompanyDetails(state, action) {
      state.loading = true;
    },
    fetchCompanyDetailsSuccess(state, action) {
      state.companyDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyPickupAddress(state, action) {
      state.loading = true;
    },
    fetchCompanyPickupAddressSuccess(state, action) {
      state.pickupAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyPickupAddressFailure(state, action) {
      state.loading = false;
    },
    fetchCompanyBillingAddress(state, action) {
      state.loading = true;
    },
    fetchCompanyBillingAddressSuccess(state, action) {
      state.billingAddresses = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyBillingAddressFailure(state, action) {
      state.loading = false;
    },
    addUser(state, action) {
      state.loading = true;
      state.error = null;
    },
    addUserSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    addUserFailure(state, action) {
      state.error = action.payload.message;
      state.loading = false;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = addUserSlice;
